export default {
  'imm5406.familyMemberTableTitle': 'Family Members',
  'imm5406.familyMemberTableFullName': 'Full name',
  'imm5406.familyMemberTableStatus': 'Status',
  'imm5406.familyMemberTableStatus.missingInformation': 'Missing Information',
  'imm5406.familyMemberTableStatus.complete': 'Complete',

  'imm5406.title.applicant': 'Applicant',
  'imm5406.title.partner':
    'Spouse, common-law partner or conjugal partner (if this applies)',
  'imm5406.title.mother': 'Mother',
  'imm5406.title.father': 'Father',
  'imm5406.title.child': 'Children',
  'imm5406.title.siblings': 'Siblings',
  'imm5406.title.formList.child': 'Child #',
  'imm5406.title.formList.siblings': 'Siblings #',

  'imm5406.description.sibling': 'Including half- and step-siblings.',
  'imm5406.description.maritalStatus.marriedPhysicallyPresent':
    'If you’re married and your spouse was physically present at the marriage, choose “married – physically present” under “marital status”',
  'imm5406.description.maritalStatus.marriedNotPhysicallyPresent':
    'If you’re married and your spouse was not physically present at the marriage, choose “married – not physically present” under “marital status”',

  'imm5406.fullName': 'Full name',
  'imm5406.dateOfBirth': 'Date of Birth (YYYY/MM/DD)',
  'imm5406.countryOfBirth': 'Country or territory of birth',
  'imm5406.applicantMaritalStatus':
    'Marital status (eg married - physically present, married - not physically present, common-law, single, divorced, widowed, separated)',
  'imm5406.partnerMaritalStatus':
    'Marital status (eg married - physically present, married - not physically present, common-law, divorced, widowed, separated, not applicable - deceased)',
  'imm5406.otherDependantMaritalStatus':
    'Marital status (eg married, common-law, single, divorced, widowed, separated, not applicable - deceased)',
  'imm5406.emailAddress': 'Email address',
  'imm5406.address':
    'Provide address below. Give city/town and country or territory (maximum 80 characters):',
  'imm5406.deceasedAddress':
    'Provide address below. If deceased, give city/town, country or territory and date (maximum 80 characters):',
  'imm5406.relationship': 'Relationship',

  'imm5406.steps.sectionA': 'Section A',
  'imm5406.steps.sectionB': 'Section B - Children',
  'imm5406.steps.sectionC': 'Section C - Siblings',
};
